<template>
  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="listaccounts-flex-1gwgqi">
    <Loader v-if="loaderEnabled" />
    <v-card elevation="0" data-qa="listaccounts-card-0r4rn16">
      <font class="body-1 font-weight-bold pb-2"
        v-text="config === 'fundingAC'
          ? $t('termDepositActions.breakDeposit.chooseFundingAcLabel')
          : $t('termDepositActions.breakDeposit.choosePayAwayAcLabel')"
      />
      <v-flex class="mt-6" data-qa="listaccounts-flex-q65zkc">
        <v-tabs
          @change="changeAccountType"
          :color="primaryColor"
          v-model="selectedAccountType"
          class="pb-2"
         data-qa="listaccounts-tabs-4bbhir">
          <v-tab :disabled="isBreakageAction && payAwayAccType === 'External'" class="text-capitalize font-weight-bold" data-qa="listaccounts-tab-h0xxs5">
            {{ $t("termDepositActions.listAC.internalButtonLabel") }}
          </v-tab>
          <v-tab v-if="isViewPayeePermittedForSme()" :disabled="isBreakageAction && payAwayAccType === 'Internal'" class="text-capitalize font-weight-bold" data-qa="listaccounts-tab-iuprfp">
            {{ $t("termDepositActions.listAC.externalButtonLabel") }}
          </v-tab>
        </v-tabs>
      </v-flex>
      <v-flex v-if="selectedAccountType === 0" data-qa="listaccounts-flex-ti9frq3">
        <template v-if="config === 'fundingAC' ? filterNODR?.length : filterNOCR?.length">
          <ListAccountsSelect
            v-model="selectedInternalPayAwayAccount"
            :items="config === 'fundingAC' ? filterNODR : filterNOCR"
            @input="updateAccounts('internal')"
            :label="config === 'fundingAC' ? 'Funding Account' : 'Maturity Account'"
          />
        </template>
        <template v-else>
          <v-row justify="center" data-qa="listaccounts-row-q5omcj">
            {{ $t('openDepositAcc.noSameBankAccountsAvailable') }}
          </v-row>
          <v-row justify="center" data-qa="listaccounts-row-9pdk8m">
            <v-btn data-qa="listaccounts-btn-ecbqbq" 
              text class="mt-6"
              :color="primaryColor"
              @click="routeToDashboard"
              v-text="$t('termDepositActions.breakDeposit.goToDashboardBtnLabel')"
            />
          </v-row>
        </template>
      </v-flex>

      <v-flex v-if="selectedAccountType === 1" data-qa="listaccounts-flex-99o227">
        <template v-if="filterExternalAccounts?.length">
          <ListAccountsSelect
            v-model="selectedExternalPayAwayAccount"
            :items="filterExternalAccounts"
            :external="true"
            :label="config === 'fundingAC' ? 'Funding Account' : 'Maturity Account'"
            @input="updateBenificiaryDetails(); updateAccounts('external')"
          />
        </template>
        <template v-else>
          <v-row justify="center" data-qa="listaccounts-row-7zfdj">
            <h2 data-qa="listaccounts-h2-q9g8s">{{ $t('openDepositAcc.noOtherBankAccountsAvailable.title') }}</h2>
            <p data-qa="listaccounts-p-qc8iyd">{{ $t('openDepositAcc.noOtherBankAccountsAvailable.content') }}</p>
          </v-row>
          <v-row justify="center" data-qa="listaccounts-row-ag2y3t">
            <v-btn data-qa="listaccounts-btn-q9cu67" 
              text class="mt-6"
              :color="primaryColor"
              @click="routeToDashboard"
              v-text="$t('termDepositActions.breakDeposit.goToDashboardBtnLabel')"
            />
          </v-row>
        </template>
      </v-flex>
    </v-card>
  </v-flex>
</template>

<script>
import commonService from '@/service/commonService.js'
import event from '@/util/event'
import _ from 'lodash'
import preload from '@/util/preload'
import Loader from '../../../components/common/Loader.vue'
import ListAccountsSelect from './ListAccountsSelect.vue'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'

export default {
  name: 'ListAccounts',
  components: { Loader, ListAccountsSelect },
  mixins: [ smeRolesMixin ],
  props: {
    config: String,
    currencyFormat: String
  },
  data () {
    return {
      selectedAccountType: 0,
      selectedExternalPayAwayAccount: '',
      selectedInternalPayAwayAccount: '',
      externalAccounts: [],
      internalAccounts: [],
      tdDetails: {},
      beneficiaryDetails: null,
      payAwayAccType: '',
      isBreakageAction: false,
      openTdSelectedFundingAccType: '',
      tdAction: '',
      loaderEnabled: false,
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts,
      accountTypeToExclude: ['TXSV', 'TXNA', 'TXEA', 'TXFR', 'TXLA'],
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  async created () {
    event.$on('payAwayAccType', args => {
      this.setAccountType(args)
    })
    event.$on('refreshExternalAccList', async args => {
      args && await this.getBeneficiaries()
    })
    event.$on('resetListAccounts', args => {
      args && this.resetAccounts()
    })
    // Fetch Permissions for SME Users
    this.permissions = this.$store.getters['profileStore/profileData']?.permissions
    await this.getAccountsWithBalance()
    await this.getBeneficiaries()
  },
  computed: {
    filterNODR () {
      if (this.internalAccounts && this.internalAccounts.length) {
        const NODRfilterAccounts = this.internalAccounts.filter((item) => {
          return item.postingsRestriction !== 'DEBIT' && item.currency === this.currencyFormat && !this.accountTypeToExclude.includes(item.accountType) &&
            !(item.accountOwnership === 'JOINT' && this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList.includes(item.modeOfOperation.code))
        })
        return NODRfilterAccounts
      } else return []
    },
    filterNOCR () {
      if (this.internalAccounts && this.internalAccounts.length) {
        const NOCRfilterAccounts = this.internalAccounts.filter((item) => {
          return item.postingsRestriction !== 'CREDIT' && item.currency === this.currencyFormat && !this.accountTypeToExclude.includes(item.accountType)
        })
        return NOCRfilterAccounts
      } else return []
    },
    filterExternalAccounts () {
      if (this.externalAccounts && this.externalAccounts.length) {
        if (this.nominatedAccountsConfig.enableNominatedAccountFeatures) {
          const filteredAccounts = this.externalAccounts.filter((item) => {
            return ((item.currency === this.currencyFormat) && item.ownAccount)
          })
          return filteredAccounts
        } else {
          const filteredAccounts = this.externalAccounts.filter((item) => {
            return item.currency === this.currencyFormat
          })
          return filteredAccounts
        }
      } else return []
    }
  },
  methods: {
    isViewPayeePermittedForSme () { return this.isSmePermissionCheckEnabled() ? this.permissions?.includes('VIEW_PAYEES') : true},
    isSmePermissionCheckEnabled () { return this.isSmeLogin && this.enableRoleBasedAccess },
    async getAccountsWithBalance () {
      this.loaderEnabled = true
      let internalAccounts = await preload.getAccountsWithBalance(JSON.parse(sessionStorage.getItem('username')))
      let accounts = this.getFilteredAccounts(internalAccounts)
      this.internalAccounts = await accounts
      this.$emit('sameAccounts', accounts)
      setTimeout(() => {
        this.loaderEnabled = false
      }, 500)
    },
    routeToDashboard () {
      setTimeout(() => {
        this.$router.push({ path: '/home' })
      }, 300)
    },
    setAccountType (props) {
      switch (props.action) {
        case 'Break':
          this.isBreakageAction = true
          if (props.accType === 'Internal') {
            this.selectedAccountType = 0
            this.payAwayAccType = 'Internal'
          } else {
            this.selectedAccountType = 1
            this.payAwayAccType = 'External'
          }
          break
        case 'Create':
          this.isBreakageAction = false
          this.openTdSelectedFundingAccType = props.accType
          this.tdAction = 'createTD'
          if (this.tdAction === 'createTD' && this.config === 'payAwayAC') {
            if (this.openTdSelectedFundingAccType === 'Internal') {
              this.selectedAccountType = 0
              this.payAwayAccType = 'Internal'
              this.isBreakageAction = true
            } else {
              this.selectedAccountType = 1
              this.isBreakageAction = true
              this.payAwayAccType = 'External'
            }
          }
          break
        default:
      }
    },
    resetAccounts () {
      this.selectedInternalPayAwayAccount = ''
      this.selectedExternalPayAwayAccount = ''
      this.beneficiaryDetails = {
        accountIdentification: '',
        beneficiaryId: ''
      }
    },
    changeAccountType () {
      this.resetAccounts()
      event.$emit('listAccounts', {
        selectedAccountType: this.selectedAccountType === 0 ? 'Internal' : 'External',
        selectedInternalPayAwayAccount: this.selectedInternalPayAwayAccount,
        selectedExternalPayAwayAccount: this.beneficiaryDetails
      })
      event.$emit('clearAccountsDetails', {
        clearAccDetailsType: this.config,
        internalAccounts: this.internalAccounts,
        externalAccounts: this.externalAccounts,
        selectedAccountType:
          this.selectedAccountType === 0 ? 'Internal' : 'External'
      })
      event.$emit('disableNextBtn', true)
    },
    updateAccounts (accountType) {
      accountType === 'internal' ? (this.selectedExternalPayAwayAccount = '') : (this.selectedInternalPayAwayAccount = '')
      event.$emit('listAccounts', {
        internalAccounts: this.internalAccounts,
        externalAccounts: this.externalAccounts,
        selectedAccountType: this.selectedAccountType === 0 ? 'Internal' : 'External',
        selectedInternalPayAwayAccount: this.selectedInternalPayAwayAccount,
        selectedExternalPayAwayAccount: this.beneficiaryDetails,
        accType: this.config
      })
      event.$emit('disableNextBtn', false)
    },
    updateBenificiaryDetails () {
      const self = this
      this.beneficiaryDetails = _.find(self.beneficiaries, o => {
        return o.accountIdentification === this.selectedExternalPayAwayAccount
      })
    },
    async getBeneficiaries () {
      const self = this
      const resp = await commonService.getBeneficiaries(JSON.parse(sessionStorage.getItem('username')))
      if (resp && resp.items) {
        this.beneficiaries = resp.items
        this.externalAccounts = []
        for (const i in resp.items) {
          const item = resp.items[i]
          this.externalAccounts.push({
            accountIdentification: item.accountIdentification,
            bankIdentifier: item.bankIdentifier,
            currency: item.currency,
            ownAccount: item.ownAccount,
            name: item.name
          })
          if (item.accountIdentification === self.tdDetails.payCapitalToAccount) {
            this.selectedExternalPayAwayAccount = item.accountIdentification
          }
        }
        this.$emit('otherAccounts', this.externalAccounts)
        this.$emit('beneficiariesList', this.beneficiaries)
        if ((this.externalAccounts && this.externalAccounts.length === 1) || this.selectedExternalPayAwayAccount) {
          this.updateBenificiaryDetails()
        }
      }
    }
  },
  beforeDestroy () {
    event.$off('payAwayAccType')
    event.$off('refreshExternalAccList')
    event.$off('resetListAccounts')
  }
}
</script>